{
  "entity": "Entity",
  "action": "Action",
  "activated": "Activated",
  "approved": "Approved",
  "reference": "Reference",
  "loading": "Loading",
  "status": {
    "status": "Status",
    "active": "Active",
    "inactive": "Never logged in",
    "deactivated": "Deactivated",
    "pendingPermission": "Pending permission",
    "pending": "Pending",
    "rejected": "Rejected",
    "inreview": "In review"
  },
  "buttons": {
    "continue": "Continue",
    "next": "Next",
    "submit": "Submit",
    "finish": "Finish",
    "back": "Back",
    "cancel": "Cancel",
    "skip": "Skip",
    "tryAgain": "Try again",
    "apply": "Apply",
    "reset": "Reset",
    "viewAll": "View all",
    "scrollToBottom": "Scroll to Bottom",
    "scrollToTop": "Scroll to Top",
    "approve": "Approve",
    "approveAnyway": "Approve Anyway",
    "reject": "Reject",
    "save": "Save",
    "close": "Close",
    "continueToSummary": "Continue to Summary",
    "completeAndClose": "Complete and Close",
    "clear": "Clear",
    "clearAll": "Clear all",
    "revert": "Revert",
    "revertAll": "Revert all",
    "selectAll": "Select all",
    "deselectAll": "Deselect all",
    "undo": "Undo",
    "yesReject": "Yes, reject",
    "yesRemove": "Yes, remove",
    "continueWithoutRetrying": "Continue without retrying"
  },
  "navigation": {
    "home": {
      "title": "Home",
      "dashboard": "Dashboard"
    },
    "transfers": {
      "transferFunds": "Transfer Funds"
    },
    "accounts": {
      "title": "Accounts",
      "balances": "Balances",
      "transactions": "Transactions",
      "invoices": "Invoices",
      "invoicing": "Invoices",
      "viewAccount": "View Account"
    },
    "deposits": {
      "title": "Deposits",
      "cash": "Cash"
    },
    "money": {
      "title": "Money",
      "payments": "Payments",
      "beneficiaries": "Beneficiaries",
      "transfers": "Balance Transfers",
      "batchSummary": "Batch Summary",
      "createPayment": "Create Payments",
      "beneficiariesCheck": "Beneficiaries Check"
    },
    "channelPayments": {
      "title": "Channel Payments",
      "payments": "API, SWIFT & SFTP"
    },
    "entity-management": {
      "title": "Entity Management",
      "entities": "Entities",
      "users": "Users",
      "onboarding": "Onboarding",
      "groups": "Groups"
    },
    "navbar": {
      "title": "Navbar"
    }
  },
  "auth": {
    "logOut": "Log out"
  },
  "multiStepFormModal": {
    "title": "Are you sure you want to close this?",
    "body": "The information you entered will not be saved",
    "cancel": "Cancel",
    "confirm": "Yes, close"
  },
  "countries": {
    "dataError": "Access to view country data for the selected accounts is restricted for the current user"
  },
  "currencies": {
    "dataError": "Access to view currency data for the selected accounts is restricted for the current user"
  },
  "field": {
    "placeholder": "Enter {{field}}",
    "required": "{{label}} is required.",
    "specialCharacters": "{{field}} must not contain special characters.",
    "minLength": "Must be at least {{numOfChars}} characters.",
    "maxLength": "Must be {{numOfChars}} characters or less.",
    "mustBeNumber": "Amount must be a number."
  },
  "entitySelector": {
    "noEntitiesSelected": "No entities currently selected",
    "allEntitiesSelected": "All entities currently selected ({{numberOfEntities}})",
    "selectedEntities": "Selected Entities ({{selectedEntities}})",
    "noEntitiesFoundOnAccount": "No entities found on your account",
    "noGroupsFoundOnAccount": "No groups found on your account",
    "noEntitiesFound": "No entities found",
    "amendSearchTerm": "Please amend search term",
    "allEntities": "All entities",
    "allSearchResults": "All search results",
    "numberOfEntities": "Number of entities: {{numberOfEntities}}",
    "selectedEntitiesInBeneficiary": "Selected Entities: {{selectedEntities}}",
    "searchEntities": "Search entities",
    "groupsLabel": "Groups",
    "entitiesLabel": "Entities",
    "entitySelectorLabel": "Entity Selector",
    "numberSelected": "{{entities}} selected",
    "viewMore": "View {{numberOfEntities}} more",
    "showLess": "Show less",
    "chips": {
      "reviewDue": "Due",
      "accountFrozen": "Frozen",
      "reviewOverDue": "Overdue"
    }
  },
  "download": {
    "errors": {
      "contactSupport": "Please contact customer support",
      "downloadLink": "There was an issue getting your download link: {{error}}.",
      "downloadPDF": "There was an error downloading your PDF.",
      "downloadReport": "There was an issue downloading your report: {{error}}.",
      "generateReport": "There was an error generating your report: {{error}}.",
      "generic": "There was an error with your request. Please contact customer support.",
      "linkNotFound": "Download link is not available.",
      "maxCurrencyAccounts": "Please only select a maximum of 40 currency accounts.",
      "validateLimit": "There was an error validating the transactions limit: {{error}}.",
      "validatingNoCAs": "There was an error validating your transactions, no currency accounts returned.",
      "downloadGenericError": "There was an error downloading your file."
    },
    "downloadInProgress": "Your download is in progress.",
    "exportInProgress": "Your export is in progress",
    "successfulExport": "Successfully exported your transactions",
    "successfulDownload": "Your PDF has been successfully downloaded.",
    "exportName": "Alpha_Ledgers"
  },
  "filter": {
    "itemsSelectedText": "{{itemsSelectedLength}} Selected",
    "clearAll": "Clear All",
    "searchInfo": "Please revise your search term and try again",
    "noResults": "No results found"
  },
  "successfulDownload": "Successfully downloaded",
  "failedDownload": "Error processing download",
  "other": "Other",
  "currencyAccountLabel": "{{currencyCode}} Account",
  "disabledEntitySelectorMessage": {
    "onEntityManagementRoute": "The selection of entities is not enabled in entity management pages, all associated entities are displayed by default",
    "onBatchSummaryRoute": "You cannot change the entity selection when viewing a batch"
  },
  "tooManyFilesWarningTitle": "You can only upload a maximum of one file in this field",
  "tooManyFilesWarningContent": "Please only upload one file.",
  "sessionExpiryText": "Your session will expire in <1>{{warningTimeRemaining}} seconds</1>",
  "sessionExpiryTitle": "Session is about to timeout",
  "invalidFileTypeWarningContent": "The chosen file type is not one that is supported:",
  "dropOnDisabledDefaultError": "Unable to drop file while disabled.",
  "inValidFileSizeWarningContent": "Please select a smaller file and try again.",
  "inValidFileSizeTitle": "The file must be smaller than",
  "banners": {
    "learnMore": "Learn more",
    "title": {
      "overdue": "Overdue KYC Review",
      "frozen": "Frozen accounts",
      "due": "Upcoming KYC Review"
    },
    "content": {
      "overdue": "One or more of your entities are overdue for a periodic KYC review. These entities are at risk of being frozen, please contact client services. ",
      "frozen": "One or more of your entities are frozen due to an overdue for a periodic KYC review. You are not able to make payments from these entities, please contact client services. ",
      "due": "One or more of your entities is coming up to the deadline for a periodic KYC review. If you do not meet the deadline then these entities may be frozen, please contact client services. "
    }
  },
  "kycReviewModal": {
    "title": "Regulatory KYC Review",
    "dueDate": "Due date",
    "verifyMessage": "<0>We understand this may be inconvenient for you, but we appreciate your cooperation in helping comply with regulatory requirements. Please contact your client services representative</0> <1>tel +44 (0)20 3854 9265</1> <0>to verify your information.</0>",
    "frozen": {
      "description": "We have a regulatory obligation to ensure that information and documentation is kept up to date. Some of your entities have passed the deadline for renewed information, and have had to be frozen.",
      "entities": "Entities frozen:",
      "alertCard": {
        "title": "Payments are not possible from frozen entities.",
        "description": "Until we re-verify your information, you are unable to make payments from frozen entities."
      }
    },
    "review": {
      "description": "We have a regulatory obligation to ensure that information and documentation is kept up to date. One or more of your entities is coming up to the deadline for a periodic re-verification.",
      "entities": "Entities:",
      "alertCard": {
        "title": "Your entities may be frozen",
        "description": "You will be unable to make payments from frozen entities until we re-verify your information."
      }
    }
  },
  "protectedTooltip": "You do not have the permissions to perform this action. Please contact the admin within your organisation.",
  "pleaseTryAgainContactClientServices": "Please try again, and if the issue persists, contact Client Services",
  "ukBankHolidayErrorMessage": "Unable to get rate due to a UK bank holiday. Please try again on the next working day.",
  "ukWeekendErrorMessage": "Unable to get rate due to a UK weekend. Please try again on the next working day.",
  "noResults": "No results.",
  "successful": "Successful",
  "failed": "Failed",
  "inProgress": "In Progress",
  "error": "Error",
  "dataRangeError": "You can only select up to 1 year at a time",
  "chips": {
    "approvers": {
      "title": "Approvals",
      "noApprovers": "No approvers yet"
    }
  },
  "brandTransitionBanner": {
    "learnMore": "Learn more",
    "followLinkedIn": "Follow LinkedIn",
    "visitCorpay": "Corpay website",
    "logoAlt": "Alpha Private Markets is changing to Corpay Private Markets logo",
    "backgroundAlt": "Alpha to Corpay brand transition background image"
  },
  "new": "New",
  "recommended": "Recommended",
  "unknownError": "Unknown Error"
}
